import { createTheme } from "@mui/material";

const customTheme = createTheme({
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputLabel-root": {
            // Default label color
            color: "black",
            "&.Mui-focused": {
              // Label color when focused
              color: "black",
            },
          },
          "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
              // Outline color when focused
              borderColor: "black",
              borderWidth: "2px",
            },
          },
          "& .MuiInputBase-input": {
            // Text color
            color: "black",
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "black", // Default color for checkbox
          "&.Mui-checked": {
            color: "black", // Color when checked
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: "36px", // Reduced height for Tabs
          "& .MuiTabs-indicator": {
            backgroundColor: "black",
            display: "none", // Indicator color
          },
          "& .MuiTabs-flexContainer": {
            borderBottom: "none", // Remove default underline
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: "32px", // Reduced height for Tab
          padding: "6px 12px", // Padding for Tab
          borderRadius: "4px", // Border radius for Tab
          "&.Mui-selected": {
            backgroundColor: "black", // Background color for selected Tab
            color: "white", // Text color for selected Tab
          },
          color: "black", // Default text color for Tab
        },
      },
    },
    MuiTreeItem: {
      styleOverrides: {
        label: {
          fontSize: "14px", // Set consistent font size for RichTreeView labels
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-root": {
            fontSize: 14, // Adjusted font size for input base
          },
          "& .MuiAutocomplete-tag": {
            fontSize: 14, // Adjusted font size for tags
          },
        },
        option: {
          fontSize: 14, // Adjusted font size for options
        },
        chip: {
          fontSize: 14, // Adjusted font size for chips
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "black",
        },
        arrow: {
          color: "black",
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: "black", // Default color
          "&.Mui-focused": {
            color: "black", // Color when focused/selected
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "black",
          "&.Mui-checked": {
            color: "black",
          },
        },
      },
    },
  },
});

export default customTheme;
